import React from "react"
import {BikeType} from "../../../utility/Types"
import {findBikeAttributeBySlug, getSizeIndex} from "../../../utility/Helper"
import Typography from "../../reusable/Typography/Typography"

type Props = {
    bike:BikeType
}

function PlpSizes({bike}: Props) {
	const sizes = bike?.attributes?.find(item => item.slug === "sizes")
	const seen = new Map()
	const sortedSizes = sizes?.terms
		?.sort((a, b) => getSizeIndex(a.name) - getSizeIndex(b.name))
		?.filter(item => {
			const key = `${item.name}|${item.slug}`
			if (!seen.has(key)) {
				seen.set(key, true)
				return true
			}

			return false
		})

	const _response = [...(bike.staticVariations || [])].sort((a, b) => {
		const sizeA = findBikeAttributeBySlug(a, "sizes", false, true)
		const sizeB = findBikeAttributeBySlug(b, "sizes", false, true)

		return getSizeIndex(sizeA) - getSizeIndex(sizeB)
	})

	bike.staticVariations = _response

	if (sortedSizes?.length) {
		return (
			<div className="d-flex align-items-center justify-content-start col-12 gap-2">
				{sortedSizes.map((item, index) => {
					if (bike?.staticVariations?.[index]?.stock_status === "outofstock") {
						return null
					}

					return <div key={index}
						className="d-flex align-items-center justify-content-center"
						style={{padding: "4px", borderRadius: "4px", background: "#F8F8F8", minWidth: "20px", height: "20px"}}>
						<Typography variant="bodySmBold">{item.name}</Typography>
					</div>
				})}
			</div>
		)
	}

	return null
}

export default PlpSizes
